import { DynamicViewData } from "src/dynamic-view-renderer/DynamicViewRenderer.typings.ts";
import { ViewConfiguration } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types.ts";
import TabbedView, { TabbedViewProps } from "src/dynamic-view-renderer/Views/TabbedView.tsx";

import { PrintableView, PrintableViewOptions } from "./Views/PrintableView/PrintableView";

export type DynamicViewBaseProps = {
  viewConfiguration: ViewConfiguration;
  data: DynamicViewData;
};

export type DynamicViewRendererProps = TabbedViewProps & { print?: PrintableViewOptions };

export const DynamicViewRenderer = (props: DynamicViewRendererProps) => {
  switch (props.viewConfiguration.type) {
    case "printableView":
      return (
        <PrintableView
          viewConfiguration={props.viewConfiguration}
          data={props.data}
          options={props.print}
        />
      );
    case "tabbedView":
      return <TabbedView {...props} />;
    default:
      return <div>Unknown view type</div>;
  }
};
